(function () {
    var config = {};

// Import variables if present (from env.js)
    if (window) {
        initForSafari();
        Object.assign(config, window.__config);
    }

    function initForSafari() {
        if (!Object.assign) {
            Object.defineProperty(Object, 'assign', {
                enumerable: false,
                configurable: true,
                writable: true,
                value: function (target, firstSource) {
                    'use strict';
                    if (target === undefined || target === null) {
                        throw new TypeError('Cannot convert first argument to object');
                    }

                    var to = Object(target);
                    for (var i = 1; i < arguments.length; i++) {
                        var nextSource = arguments[i];
                        if (nextSource === undefined || nextSource === null) {
                            continue;
                        }

                        var keysArray = Object.keys(Object(nextSource));
                        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                            var nextKey = keysArray[nextIndex];
                            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                            if (desc !== undefined && desc.enumerable) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                    return to;
                }
            });
        }

        //.....................

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                return this.substr(position || 0, searchString.length) === searchString;
            };
        }
    }

    var app = angular
        .module('tikonApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            // 'leaflet',
            // 'leaflet-directive',
            // 'nemLogging',
            // 'ui-leaflet',

            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'lr.upload',
            'persian_datepicker',
            'ngImgCrop',
            'thatisuday.ng-image-gallery'
            , 'ngMaterial',
            'summernote',
            'smart-table',
            'ui.bootstrap.modal',
            'angular-img-cropper',
            'angular-momentjs',
            'rzModule',
            'vcRecaptcha',
            'chart.js',
            'ngJoyRide',
            'ngMap',
            'mgo-angular-wizard',
            'ngMessages',
            'moment-picker'
            //'md.time.picker'order
            //'cmGoogleApi'
            //,'720kb.socialshare'
        ]).config(['$mdThemingProvider', function ($mdThemingProvider) {

            $mdThemingProvider.theme('default')
                .primaryPalette('blue-grey')
                .backgroundPalette('grey')
                .warnPalette('red')
                .accentPalette('orange');
        }])
        .config(['$mdGestureProvider', function ($mdGestureProvider) {
            $mdGestureProvider.skipClickHijack();
        }])
        //.config(['googleClientProvider',function (googleClientProvider) {
        //    googleClientProvider
        //        .loadPickerLibrary()
        //        .loadGoogleAuth({
        //            cookie_policy: 'single_host_origin',
        //            hosted_domain: '    localhost:8080',
        //            fetch_basic_profile: true
        //        })
        //        .setClientId('26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com')
        //        //.addScope('a scope')
        //        //.addScope('another scope')
        //        //.addApi('myApi', 'v1', 'https://app-id.appspot.com/_ah/api')
        //        .addApi('oauth2', 'v2');
        //}])
        .constant('__config', config).run(run);


    run.$inject = ['stateHandler', 'translationHandler', 'PushNotificationService', '$timeout' , 'ENV'];


    //app.config(['$googleClientProvider',function (googleClientProvider) {
    //    googleClientProvider
    //        .loadPickerLibrary()
    //        .loadGoogleAuth({
    //            cookie_policy: 'single_host_origin',
    //            hosted_domain: '    localhost:8080',
    //            fetch_basic_profile: true
    //        })
    //        .setClientId('26554230915-f6jfkijap7k1arflsi80278isjjhmqko.apps.googleusercontent.com')
    //        //.addScope('a scope')
    //        //.addScope('another scope')
    //        //.addApi('myApi', 'v1', 'https://app-id.appspot.com/_ah/api')
    //        .addApi('oauth2', 'v2');
    // }]);
    function run(stateHandler, translationHandler, PushNotificationService, $timeout, ENV) {
        stateHandler.initialize();
        translationHandler.initialize();

        PushNotificationService.initPushNotification()


        //set cdn url of panel-vue
        window.NEWPANEL_CDN = ENV.NEWPANEL_CDN; 
        //load vue panel script
        // $timeout(loadPanelVueScript, 50);
        loadPanelVueScript()
        function loadPanelVueScript() {
            var script = document.createElement('script');
            script.type = "module";
            script.src = ENV.NEWPANEL_CDN + "planovin-panel-starter.js?v=" + new Date().getTime();
            script.defer = true;
            document.head.appendChild(script)
        }
    }


})();
